import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import App from "../views/app/App.vue";
import Home from "../views/Home.vue";
import DynamicResource from "../views/dynamic/DynamicResource";
import Configuration from "../views/config/Configuration";
import RemoteConfig from "../views/remote/RemoteConfig";
import Tools from "../views/tool/Tools";

Vue.use(VueRouter);

const routes = [
	{
		path: "/oidc/login",
		name: "Home",
		component: Home,
		meta: {
			independentPage: true
		}
	},
	{
		path: "/",
		name: "Login",
		component: Login,
		meta: {
			independentPage: true
		}
	},
  	{
		path: '/app',
		name: 'App',
		component: App,
		meta: {
			independentPage: false
		}
	},
  	{
		path: '/dynamicResource',
		name: 'DynamicResource',
		component: DynamicResource,
		meta: {
			independentPage: false
		}
	},
  	{
		path: '/configuration',
		name: 'Configuration',
		component: Configuration,
		meta: {
			independentPage: false
		}
	},
  	{
		path: '/remoteConfig',
		name: 'RemoteConfig',
		component: RemoteConfig,
		meta: {
			independentPage: false
		}
	},
  	{
		path: '/tools',
		name: 'Tools',
		component: Tools,
		meta: {
			independentPage: false
		}
	},
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

// 解决重复点击控制台报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
};

export default router;
